<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <v-tabs
            show-arrows
            :height="32"
            class="tabs-route"
            background-color="transparent"
            slider-color="primary">
            <v-tab >
                Genera Ordini di Acquisto
            </v-tab>
        </v-tabs>
        <v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                :infos="infos"
                topClass=""
            ></show>


            <v-col class="pa-0 pb-4" v-if="relations.products">
                <v-card class="flex pa-0 background-2 round-card">
                    <v-card-title class="pa-3">
                        <p class="pl-2 pl-xl-3">Genera Ordini di Acquisto</p>
                        <v-spacer></v-spacer>
                        <v-text-field
                            class="hidden-xs-only font-weight-regular mr-4"
                            append-icon="mdi-magnify"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                        <v-switch
                            inset
                            style="padding-top: 0; margin: auto; margin-right: 16px"
                            label="Nascondi completati"
                            v-model="hideCompleted"
                            hide-details
                            color="primary"
                        ></v-switch>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    class="ml-4 d-md-none"
                                    @click="showBulkActions = !showBulkActions"
                                    :color="showBulkActions ? 'primary' : 'default'">
                                    <v-icon>mdi-file-cog-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Azioni rapide</span>
                        </v-tooltip>
                        <v-btn
                            class="ml-4 d-none d-md-flex"
                            @click="showBulkActions = !showBulkActions"
                            :color="showBulkActions ? 'primary' : 'default'"
                            outlined>
                            <v-icon left>mdi-file-cog-outline</v-icon>
                            Azioni rapide
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>

                    <!-- Expansion Panel per Azioni Rapide -->
                    <v-expand-transition>
                        <div v-show="showBulkActions" class="pa-3 background-1">
                            <div class="d-flex align-center justify-space-between mb-2">
                                <h5 class="mb-0">Azioni Rapide</h5>
                            </div>
                            <v-divider class="my-2"></v-divider>
                            <v-row dense align="center" class="mx-0">
                                <v-col cols="12" md="3" class="pa-1">
                                    <strong style="font-size: 12px;">Imposta Fornitore</strong>
                                </v-col>
                                <v-col cols="12" md="5" class="pa-1">
                                    <v-autocomplete
                                        v-model="bulkSupplierId"
                                        :items="globalSuppliers"
                                        label="Fornitore"
                                        dense
                                        outlined
                                        hide-details
                                        clearable
                                        :menu-props="{maxHeight:'200', 'offset-y': true}"
                                        style="font-size: 12px;">
                                        <template v-slot:item="data">
                                            <v-list-item-avatar
                                                size="32px"
                                                class="primary mr-4">
                                                <v-icon class="fs18i" color="white">mdi-store</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                <v-list-item-subtitle v-if="data.item.subtitle">
                                                    <span>{{ data.item.subtitle }}</span>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4" class="pa-1">
                                    <v-btn
                                        color="primary"
                                        @click="applyBulkSupplier"
                                        :disabled="!bulkSupplierId || selectableItemsCount === 0">
                                        <v-icon left small>mdi-check</v-icon>
                                        Applica a selezionati ({{ selectableItemsCount }})
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row dense align="center" class="mx-0">
                                <v-col cols="12" md="3" class="pa-1">
                                    <strong style="font-size: 12px;">Da magazzino</strong>
                                </v-col>
                                <v-col cols="12" md="9" class="pa-1">
                                    <v-btn
                                        outlined
                                        color="primary"
                                        @click="resetFromStock"
                                        :disabled="selectableItemsCount === 0">
                                        <v-icon left small>mdi-restore</v-icon>
                                        Azzera da magazzino ({{ selectableItemsCount }})
                                    </v-btn>
                                    <span class="text-caption grey--text ml-2">Ordina al fornitore tutta la quantità rimanente</span>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                    <v-container class="pa-0" fluid>
                        <v-row class="ma-0 pt-0">
                            <v-col cols="12" class="pt-0">
                                <v-card class="flex background-2" elevation="0">
                                    <v-data-table
                                        class="background-2 no-max-height"
                                        :headers="relations.products.info.fieldDefs"
                                        :items="filteredItems"
                                        :search="search"
                                        v-model="selectedRows"
                                        show-select
                                        show-expand
                                        item-key="id"
                                        hide-default-footer
                                        disable-pagination
                                        :expanded.sync="expandedRows"
                                        :item-class="getRowClass"
                                        @toggle-select-all="onToggleSelectAll">

                                        <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                            <v-simple-checkbox
                                                v-if="item.type !== 'kit'"
                                                :value="isSelected"
                                                @input="select($event)"
                                                color="primary"
                                            ></v-simple-checkbox>
                                            <v-icon v-else color="primary" small>mdi-package-variant-closed</v-icon>
                                        </template>

                                        <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
                                            <v-btn
                                                v-if="item.type === 'kit'"
                                                icon
                                                small
                                                @click="expand(!isExpanded)">
                                                <v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </v-btn>
                                        </template>

                                        <template v-slot:item.name="{ item }">
                                            <div class="d-flex align-center">
                                                <v-icon v-if="item.type === 'kit'" color="primary" small class="mr-2">mdi-package-variant-closed</v-icon>
                                                {{ item.name }}
                                                <v-chip v-if="item.type === 'kit'" x-small color="primary" class="ml-2" outlined>KIT</v-chip>
                                            </div>
                                        </template>

                                        <template v-slot:item.number="{ index }">
                                            {{ index + 1 }}
                                        </template>

                                        <template v-slot:item.quantity="{ item }">
                                            <v-chip small color="grey darken-1" dark>
                                                <v-icon small left>mdi-package-variant</v-icon>
                                                {{ item.quantity }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.quantity_already_ordered="{ item }">
                                            <template v-if="item.type !== 'kit'">
                                                <v-chip
                                                    small
                                                    :color="item.quantity_already_ordered > 0 ? 'info' : 'grey lighten-1'"
                                                    :dark="item.quantity_already_ordered > 0">
                                                    <v-icon small left>mdi-cart-check</v-icon>
                                                    {{ item.quantity_already_ordered }}
                                                </v-chip>
                                            </template>
                                            <span v-else class="grey--text">-</span>
                                        </template>

                                        <template v-slot:item.quantity_remaining="{ item }">
                                            <template v-if="item.type !== 'kit'">
                                                <v-chip
                                                    small
                                                    :color="item.quantity_remaining > 0 ? 'error' : 'success'"
                                                    dark>
                                                    <v-icon small left>{{ item.quantity_remaining > 0 ? 'mdi-alert-circle' : 'mdi-check-circle' }}</v-icon>
                                                    {{ item.quantity_remaining }}
                                                </v-chip>
                                            </template>
                                            <span v-else class="grey--text">Vedi componenti</span>
                                        </template>

                                        <template v-slot:item.available_quantity="{ item }">
                                            <template v-if="item.type !== 'kit' && item.type !== 'description'">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-chip
                                                            v-on="on"
                                                            x-small
                                                            :color="availabilityColor(item)"
                                                            :dark="item.available_quantity > 0">
                                                            <v-icon x-small left>mdi-warehouse</v-icon>
                                                            {{ item.available_quantity === null ? '-' : item.available_quantity }}
                                                        </v-chip>
                                                    </template>
                                                    <span>{{ availabilityTooltip(item) }}</span>
                                                </v-tooltip>
                                            </template>
                                            <span v-else-if="item.type === 'kit'" class="grey--text">Vedi componenti</span>
                                        </template>

                                        <template v-slot:item.from_stock="{ item }">
                                            <template v-if="item.type !== 'kit' && item.type !== 'description'">
                                                <v-text-field
                                                    :disabled="!isRowSelected(item) || item.is_fully_ordered || item.available_quantity === null"
                                                    label="Da magazzino"
                                                    v-model="item.from_stock"
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    persistent-hint
                                                    :hint="item.from_stock > item.available_quantity ? 'Oltre la disponibilità' : ''"
                                                    @input="onFromStockChange(item)"
                                                    @change="onFromStockChange(item, true)"
                                                ></v-text-field>
                                            </template>
                                            <span v-else>-</span>
                                        </template>

                                        <template v-slot:item.supplier_id="{ item, index }">
                                            <template v-if="item.type !== 'kit' && item.type !== 'description'">
                                                <v-autocomplete
                                                    autocomplete="no"
                                                    :disabled="!isRowSelected(item) || item.is_fully_ordered"
                                                    label="Fornitore"
                                                    :items="getSuppliers(item)"
                                                    v-model="item.supplier_id"
                                                    :menu-props="{maxHeight:'200'}"
                                                    clearable
                                                    dense
                                                    outlined
                                                    hide-details
                                                    v-validate="!isRowSelected(item) || !(item.quantity_to_order > 0) ? '' : 'required'"
                                                    :error-messages="errors.collect('Fornitore_'+index)"
                                                    data-vv-as="Fornitore"
                                                    :data-vv-name="'Fornitore_'+index"
                                                    @change="onSupplierChange(item, $event)">
                                                    <template v-slot:item="data">
                                                        <v-list-item-avatar
                                                            size="32px"
                                                            class="primary mr-4">
                                                            <v-icon class="fs18i" color="white">mdi-store</v-icon>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                            <v-list-item-subtitle v-if="data.item.subtitle">
                                                                <span>{{ data.item.subtitle }}</span>
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-autocomplete>
                                            </template>
                                            <span v-else-if="item.type === 'kit'" class="grey--text text-caption">Seleziona nei componenti</span>
                                        </template>

                                        <template v-slot:item.purchase_price="{ item }">
                                            <template v-if="item.type !== 'kit' && item.type !== 'description'">
                                                <v-text-field
                                                    :disabled="!isRowSelected(item) || item.is_fully_ordered"
                                                    label="Prezzo"
                                                    v-model.number="item.purchase_price"
                                                    type="number"
                                                    step="0.01"
                                                    dense
                                                    outlined
                                                    hide-details
                                                ></v-text-field>
                                            </template>
                                            <span v-else>-</span>
                                        </template>

                                        <template v-slot:item.quantity_to_order="{ item, index }">
                                            <template v-if="item.type !== 'kit' && item.type !== 'description'">
                                                <v-text-field
                                                    :disabled="!isRowSelected(item) || item.is_fully_ordered"
                                                    label="Quantità"
                                                    v-model.number="item.quantity_to_order"
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    dense
                                                    outlined
                                                    hide-details
                                                    v-validate="!isRowSelected(item) ? '' : 'required|min_value:0'"
                                                    :error-messages="errors.collect('Quantità_'+index)"
                                                    data-vv-as="Quantità"
                                                    :data-vv-name="'Quantità_'+index"
                                                ></v-text-field>
                                            </template>
                                            <span v-else>-</span>
                                        </template>

                                        <!-- Expanded row per i kit -->
                                        <template v-slot:expanded-item="{ headers, item: kitItem }">
                                            <td :colspan="headers.length" class="pa-4" style="background: #f5f5f5">
                                                <v-card outlined class="round-card">
                                                    <v-card-title class="pa-3">
                                                        <v-icon left color="primary">mdi-package-variant-closed</v-icon>
                                                        Componenti Kit: {{ kitItem.name }}
                                                    </v-card-title>
                                                    <v-divider></v-divider>
                                                    <v-simple-table dense class="components-table">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 50px"></th>
                                                                <th>Componente</th>
                                                                <th>Unità</th>
                                                                <th class="text-center">Q.tà Richiesta</th>
                                                                <th class="text-center">Stock</th>
                                                                <th class="text-center">Disponibile</th>
                                                                <th>Da magazzino</th>
                                                                <th class="text-center">Già Ordinato</th>
                                                                <th>Da Ordinare</th>
                                                                <th>Fornitore</th>
                                                                <th>Prezzo Acquisto</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(comp, ci) in kitItem.components" :key="ci">
                                                                <td>
                                                                    <v-simple-checkbox
                                                                        v-model="comp.selected"
                                                                        color="primary"
                                                                    ></v-simple-checkbox>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <strong>{{ comp.component_name }}</strong>
                                                                        <div class="text-caption grey--text">{{ comp.component_code }}</div>
                                                                    </div>
                                                                </td>
                                                                <td>{{ comp.unit_text || '-' }}</td>
                                                                <td class="text-center">
                                                                    <v-chip small color="grey darken-1" dark>
                                                                        {{ comp.required_quantity }}
                                                                    </v-chip>
                                                                </td>
                                                                <td class="text-center">
                                                                    <v-chip small :color="comp.stock_available > 0 ? 'success' : 'grey'" :dark="comp.stock_available > 0">
                                                                        <v-icon small left>mdi-warehouse</v-icon>
                                                                        {{ comp.stock_available }}
                                                                    </v-chip>
                                                                </td>
                                                                <td class="text-center">
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-chip
                                                                                v-on="on"
                                                                                small
                                                                                :color="availabilityColor(comp)"
                                                                                :dark="comp.available_quantity > 0">
                                                                                <v-icon x-small left>mdi-warehouse</v-icon>
                                                                                {{ comp.available_quantity === null ? '-' : comp.available_quantity }}
                                                                            </v-chip>
                                                                        </template>
                                                                        <span>{{ availabilityTooltip(comp) }}</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        :disabled="!comp.selected || comp.available_quantity === null"
                                                                        v-model="comp.from_stock"
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        dense
                                                                        outlined
                                                                        hide-details="auto"
                                                                        persistent-hint
                                                                        :hint="comp.from_stock > comp.available_quantity ? 'Oltre la disponibilità' : ''"
                                                                        style="max-width: 110px"
                                                                        @input="onFromStockChange(comp)"
                                                                        @change="onFromStockChange(comp, true)"
                                                                    ></v-text-field>
                                                                </td>
                                                                <td class="text-center">
                                                                    <v-chip small :color="comp.quantity_already_ordered > 0 ? 'info' : 'grey lighten-1'" :dark="comp.quantity_already_ordered > 0">
                                                                        <v-icon small left>mdi-cart-check</v-icon>
                                                                        {{ comp.quantity_already_ordered }}
                                                                    </v-chip>
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        :disabled="!comp.selected"
                                                                        v-model.number="comp.quantity_to_order"
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        dense
                                                                        outlined
                                                                        hide-details
                                                                        style="max-width: 100px"
                                                                    ></v-text-field>
                                                                </td>
                                                                <td>
                                                                    <v-autocomplete
                                                                        autocomplete="no"
                                                                        :disabled="!comp.selected"
                                                                        label="Fornitore"
                                                                        :items="getComponentSuppliers(comp)"
                                                                        v-model="comp.supplier_id"
                                                                        :menu-props="{maxHeight:'200'}"
                                                                        clearable
                                                                        dense
                                                                        outlined
                                                                        hide-details
                                                                        style="min-width: 200px"
                                                                        @change="onComponentSupplierChange(comp, $event)">
                                                                        <template v-slot:item="data">
                                                                            <v-list-item-content>
                                                                                <v-list-item-title>{{ data.item.text }}</v-list-item-title>
                                                                                <v-list-item-subtitle v-if="data.item.subtitle">
                                                                                    {{ data.item.subtitle }}
                                                                                </v-list-item-subtitle>
                                                                            </v-list-item-content>
                                                                        </template>
                                                                    </v-autocomplete>
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        :disabled="!comp.selected"
                                                                        v-model.number="comp.purchase_price"
                                                                        type="number"
                                                                        step="0.01"
                                                                        suffix="€"
                                                                        dense
                                                                        outlined
                                                                        hide-details
                                                                        style="max-width: 100px"
                                                                    ></v-text-field>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </v-card>
                                            </td>
                                        </template>

                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>

            <!-- FAB Button -->
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-fab-transition slot="activator">
                        <v-btn
                            v-on="{ ...tooltip }"
                            @click.native="showGenerateDialog"
                            :disabled="!hasValidSelection"
                            color="primary"
                            dark
                            fixed
                            bottom
                            right
                            fab>
                            <v-icon>mdi-cart-arrow-down</v-icon>
                        </v-btn>
                    </v-fab-transition>
                </template>
                <span>Genera Ordini di Acquisto</span>
            </v-tooltip>

            <!-- Generate Dialog -->
            <v-dialog v-model="generateDialog" max-width="800px" persistent>
                <v-card class="background-2 round-card">
                    <v-card-title class="pa-3">
                        <v-icon left>mdi-cart-arrow-down</v-icon>
                        <p class="pl-2 pl-xl-3">Genera Ordini di Acquisto</p>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4 body-2">
                        <v-alert type="info" text dense class="mb-4">
                            <div class="d-flex align-center">
                                <v-icon color="info" class="mr-2">mdi-information</v-icon>
                                <span>Verranno generati <strong>{{ ordersToGenerate.length }}</strong> ordini di acquisto raggruppati per fornitore</span>
                            </div>
                        </v-alert>

                        <v-switch
                            v-model="useSameSectional"
                            label="Usa stesso sezionale per tutti gli ordini"
                            color="primary"
                            class="mb-4"
                            inset
                        ></v-switch>

                        <v-autocomplete
                            v-if="useSameSectional"
                            v-model="defaultSectionalId"
                            :items="sectionals"
                            item-text="text"
                            item-value="value"
                            label="Sezionale"
                            outlined
                            dense
                            v-validate="'required'"
                            :error-messages="errors.collect('Sezionale')"
                            data-vv-name="Sezionale"
                            data-vv-as="Sezionale"
                            class="mb-4"
                        ></v-autocomplete>

                        <v-card outlined class="round-card elevation-0">
                            <v-list dense v-if="!useSameSectional && ordersToGenerate.length > 0">
                                <v-subheader>Ordini da generare</v-subheader>
                                <v-list-item v-for="(order, index) in ordersToGenerate" :key="index">
                                    <v-list-item-avatar color="primary">
                                        <v-icon color="white">mdi-store</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ order.supplier_name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ order.products_count }} prodotti</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action style="flex-direction: row; width: 300px">
                                        <v-autocomplete
                                            v-model="sectionals_map[order.supplier_id]"
                                            :items="sectionals"
                                            item-text="text"
                                            item-value="value"
                                            label="Sezionale"
                                            outlined
                                            dense
                                            hide-details
                                            v-validate="'required'"
                                            :error-messages="errors.collect('Sezionale_'+order.supplier_id)"
                                            :data-vv-name="'Sezionale_'+order.supplier_id"
                                            data-vv-as="Sezionale"
                                        ></v-autocomplete>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="generateDialog = false">Annulla</v-btn>
                        <v-btn
                            color="primary"
                            @click="confirmGenerate"
                            :loading="generating">
                            <v-icon left>mdi-check</v-icon>
                            Genera Ordini
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-col>
    </v-row>
</template>

<script>
import Vue from 'vue'
import Show from '@/components/common/Show'

export default {
    name: 'saleorder-generate-purchaseorders',

    components: {
        Show
    },

    props: {
        id: {
            type: Number,
            required: true
        },
    },

    data() {
        return {
            search: '',
            modelDef: 'saleorders',
            models: {},
            infos: {},
            relations: {},
            selectedRows: [],
            expandedRows: [],
            hideCompleted: true,
            generateDialog: false,
            useSameSectional: true,
            defaultSectionalId: null,
            sectionals: [],
            sectionals_map: {},
            generating: false,
            // Fornitori globali (se allow_all_suppliers = true)
            globalSuppliers: [],
            productSupplierPrices: {},
            // Azioni rapide
            showBulkActions: false,
            bulkSupplierId: null,
            // Headers per la tabella componenti kit
            componentHeaders: [
                { text: '', value: 'selected', sortable: false, width: '50px' },
                { text: 'Componente', value: 'component_name', sortable: false },
                { text: 'Q.tà Richiesta', value: 'required_quantity', sortable: false, align: 'center' },
                { text: 'Stock', value: 'stock_available', sortable: false, align: 'center' },
                { text: 'Disponibile', value: 'available_quantity', sortable: false, align: 'center' },
                { text: 'Da magazzino', value: 'from_stock', sortable: false },
                { text: 'Già Ordinato', value: 'quantity_already_ordered', sortable: false, align: 'center' },
                { text: 'Da Ordinare', value: 'quantity_to_order', sortable: false },
                { text: 'Fornitore', value: 'supplier_id', sortable: false },
                { text: 'Prezzo', value: 'purchase_price', sortable: false },
            ],
        }
    },

    created() {
        this.loadData()
    },

    computed: {
        filteredItems() {
            let filtered = this.relations.products ? this.relations.products.collection : []

            if (this.hideCompleted) {
                filtered = filtered.filter(item => !item.is_fully_ordered)
            }

            return filtered
        },

        // Verifica se c'è almeno una selezione valida (prodotti normali o componenti kit):
        // serve un fornitore e una quantità da ordinare > 0 (le righe coperte dal magazzino non generano ordini)
        hasValidSelection() {
            // Controlla prodotti normali selezionati
            const hasNormalProducts = this.selectedRows.some(row => row.type !== 'kit' && row.supplier_id && row.quantity_to_order > 0)

            // Controlla componenti kit selezionati
            const hasKitComponents = this.filteredItems.some(item => {
                if (item.type !== 'kit' || !item.components) return false
                return item.components.some(comp => comp.selected && comp.supplier_id && comp.quantity_to_order > 0)
            })

            return hasNormalProducts || hasKitComponents
        },

        ordersToGenerate() {
            const grouped = {}

            // Prodotti normali selezionati
            this.selectedRows.forEach(row => {
                if (row.type === 'kit') return // Salta kit
                if (!row.supplier_id) return
                if (!(row.quantity_to_order > 0)) return // Coperta dal magazzino

                if (!grouped[row.supplier_id]) {
                    grouped[row.supplier_id] = {
                        supplier_id: row.supplier_id,
                        supplier_name: this.getSupplierName(row),
                        products_count: 0
                    }
                }

                grouped[row.supplier_id].products_count++
            })

            // Componenti kit selezionati
            this.filteredItems.forEach(item => {
                if (item.type !== 'kit' || !item.components) return

                item.components.forEach(comp => {
                    if (!comp.selected || !comp.supplier_id) return
                    if (!(comp.quantity_to_order > 0)) return // Coperto dal magazzino

                    if (!grouped[comp.supplier_id]) {
                        grouped[comp.supplier_id] = {
                            supplier_id: comp.supplier_id,
                            supplier_name: this.getComponentSupplierName(comp),
                            products_count: 0
                        }
                    }

                    grouped[comp.supplier_id].products_count++
                })
            })

            return Object.values(grouped)
        },

        // Conta tutti gli elementi a cui si può applicare un fornitore (righe normali + componenti kit)
        selectableItemsCount() {
            let count = 0

            // Conta prodotti normali selezionati (escludendo kit e description)
            this.selectedRows.forEach(row => {
                if (row.type !== 'kit' && row.type !== 'description') {
                    count++
                }
            })

            // Conta componenti kit selezionati
            this.filteredItems.forEach(item => {
                if (item.type === 'kit' && item.components) {
                    item.components.forEach(comp => {
                        if (comp.selected) {
                            count++
                        }
                    })
                }
            })

            return count
        }
    },

    watch: {
        generateDialog(newValue) {
            if (!newValue) {
                // Resetta lo stato del dialog quando viene chiuso
                this.useSameSectional = true
                this.defaultSectionalId = null
                this.sectionals_map = {}
                this.generating = false

                // Cancella tutti gli errori di validazione
                this.$nextTick(() => {
                    if (this.$validator) {
                        this.$validator.errors.clear()
                    }
                })
            }
        }
    },

    methods: {
        loadData() {
            this.axios.get('saleorders-info-generate-purchaseorders/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                this.relations = response.data.relations

                // Salva fornitori globali se presenti
                if (response.data.suppliers) {
                    this.globalSuppliers = response.data.suppliers
                    this.productSupplierPrices = response.data.product_supplier_prices || {}
                }

                // Salva sezionali
                if (response.data.sectionals) {
                    this.sectionals = response.data.sectionals
                }

                // Espandi automaticamente i kit
                this.$nextTick(() => {
                    this.expandedRows = this.filteredItems.filter(item => item.type === 'kit')
                })

                this.$store.commit('endProgress')
            }, response => {
                this.$store.commit('endProgress')
                this.$store.commit('setSnackbarError')
            })
        },

        isRowSelected(item) {
            return this.selectedRows.some(row => row.id === item.id)
        },

        getSuppliers(item) {
            // Se ci sono fornitori globali, usa quelli
            if (this.globalSuppliers.length > 0) {
                return this.globalSuppliers
            }
            // Altrimenti usa fornitori specifici della riga
            return item.suppliers || []
        },

        getComponentSuppliers(comp) {
            // Se ci sono fornitori globali, usa quelli
            if (this.globalSuppliers.length > 0) {
                return this.globalSuppliers
            }
            // Altrimenti usa fornitori specifici del componente
            return comp.suppliers || []
        },

        onSupplierChange(item, supplierId) {
            if (!supplierId) return

            // Il listino del fornitore e' per unita' base: sulla riga in un'altra unita' (es. confezione da 12)
            // il prezzo va moltiplicato per il fattore della riga
            const factor = parseFloat(item.unit_factor) || 1
            const rowPrice = (price) => Math.round(parseFloat(price) * factor * 100000) / 100000

            // Usa mappa globale prezzi se disponibile
            if (this.productSupplierPrices[item.product_id] &&
                this.productSupplierPrices[item.product_id][supplierId]) {
                Vue.set(item, 'purchase_price', rowPrice(this.productSupplierPrices[item.product_id][supplierId]))
            } else if (item.suppliers) {
                // Fallback: usa prezzo da suppliers array della riga
                const supplier = item.suppliers.find(s => s.value === supplierId)
                if (supplier && supplier.purchase_price) {
                    Vue.set(item, 'purchase_price', rowPrice(supplier.purchase_price))
                }
            }
        },

        onComponentSupplierChange(comp, supplierId) {
            if (!supplierId) return

            // Usa mappa globale prezzi se disponibile
            if (this.productSupplierPrices[comp.component_id] &&
                this.productSupplierPrices[comp.component_id][supplierId]) {
                Vue.set(comp, 'purchase_price', this.productSupplierPrices[comp.component_id][supplierId])
            } else if (comp.suppliers) {
                const supplier = comp.suppliers.find(s => s.value === supplierId)
                if (supplier && supplier.purchase_price) {
                    Vue.set(comp, 'purchase_price', supplier.purchase_price)
                }
            }
        },

        getSupplierName(row) {
            const suppliers = this.getSuppliers(row)
            const supplier = suppliers.find(s => s.value === row.supplier_id)
            return supplier ? supplier.text : 'Fornitore sconosciuto'
        },

        getComponentSupplierName(comp) {
            const suppliers = this.getComponentSuppliers(comp)
            const supplier = suppliers.find(s => s.value === comp.supplier_id)
            return supplier ? supplier.text : 'Fornitore sconosciuto'
        },

        // "Seleziona tutto" della tabella: i componenti dei kit hanno una propria casella (comp.selected),
        // la stessa azione li seleziona o deseleziona insieme alle righe visibili
        onToggleSelectAll({ items, value }) {
            items.forEach(item => {
                if (item.type === 'kit' && item.components) {
                    item.components.forEach(comp => Vue.set(comp, 'selected', value))
                }
            })
        },

        applyBulkSupplier() {
            if (!this.bulkSupplierId || this.selectableItemsCount === 0) return

            let updatedCount = 0

            // Applica ai prodotti normali selezionati
            this.selectedRows.forEach(row => {
                // Salta kit e description
                if (row.type === 'kit' || row.type === 'description') return

                // Imposta il fornitore
                Vue.set(row, 'supplier_id', this.bulkSupplierId)

                // Aggiorna il prezzo di acquisto
                this.onSupplierChange(row, this.bulkSupplierId)

                updatedCount++
            })

            // Applica ai componenti kit selezionati
            this.filteredItems.forEach(item => {
                if (item.type === 'kit' && item.components) {
                    item.components.forEach(comp => {
                        if (comp.selected) {
                            // Imposta il fornitore
                            Vue.set(comp, 'supplier_id', this.bulkSupplierId)

                            // Aggiorna il prezzo di acquisto
                            this.onComponentSupplierChange(comp, this.bulkSupplierId)

                            updatedCount++
                        }
                    })
                }
            })

            this.$store.commit('setSnackbar', {
                timeout: 3000,
                text: `Fornitore applicato a ${updatedCount} righe`,
                value: true,
                color: 'success'
            })

            // Reset del fornitore selezionato
            this.bulkSupplierId = null
        },

        showGenerateDialog() {
            // Resetta tutti gli errori prima di validare
            this.$validator.errors.clear()

            let hasErrors = false

            // Verifica prodotti normali selezionati
            this.selectedRows.forEach((row) => {
                if (row.type === 'kit' || row.type === 'description') return // Salta kit e description

                const tableIndex = this.filteredItems.findIndex(item => item.id === row.id)

                // Quantità 0 ammessa: riga coperta dal magazzino, non genera ordine
                if (!this.isValidQuantity(row.quantity_to_order)) {
                    this.$validator.errors.add({
                        field: 'Quantità_' + tableIndex,
                        msg: 'La quantità non è valida'
                    })
                    hasErrors = true
                }

                if (row.quantity_to_order > 0 && !row.supplier_id) {
                    this.$validator.errors.add({
                        field: 'Fornitore_' + tableIndex,
                        msg: 'Il fornitore è obbligatorio'
                    })
                    hasErrors = true
                }
            })

            // Verifica componenti kit selezionati
            this.filteredItems.forEach(item => {
                if (item.type !== 'kit' || !item.components) return

                item.components.forEach(comp => {
                    if (!comp.selected) return

                    if (comp.quantity_to_order > 0 && !comp.supplier_id) {
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: `Seleziona un fornitore per il componente "${comp.component_name}"`,
                            value: true,
                            color: 'error'
                        })
                        hasErrors = true
                    }

                    if (!this.isValidQuantity(comp.quantity_to_order)) {
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: `Inserisci una quantità valida per il componente "${comp.component_name}"`,
                            value: true,
                            color: 'error'
                        })
                        hasErrors = true
                    }
                })
            })

            if (hasErrors) {
                this.$store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Completa tutti i campi obbligatori',
                    value: true,
                    color: 'error'
                })
                return false
            }

            this.generateDialog = true
        },

        confirmGenerate() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return false
                }

                this.generating = true

                // Prepara payload con prodotti normali e kit
                const products = []

                // Aggiungi prodotti normali selezionati (solo con quantità da ordinare > 0)
                this.selectedRows.forEach(row => {
                    if (row.type === 'kit') return
                    if (!(row.quantity_to_order > 0)) return

                    products.push({
                        ...row,
                        selected: true
                    })
                })

                // Aggiungi kit con i soli componenti selezionati e con quantità da ordinare > 0
                this.filteredItems.forEach(item => {
                    if (item.type !== 'kit' || !item.components) return

                    const componentsToOrder = item.components.filter(comp => comp.selected && comp.quantity_to_order > 0)
                    if (componentsToOrder.length === 0) return

                    products.push({
                        ...item,
                        selected: true,
                        components: componentsToOrder
                    })
                })

                const payload = {
                    products: products,
                    use_same_sectional: this.useSameSectional,
                    default_sectional_id: this.defaultSectionalId,
                    sectionals: this.sectionals_map
                }

                this.axios.post('saleorders-generate-purchaseorders/' + this.id, payload).then(response => {
                    this.generating = false
                    this.generateDialog = false

                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: response.data.message,
                        value: true,
                        color: 'success'
                    })

                    // Torna alla vista ordine
                    this.$router.push({ name: 'saleorders-show', params: { id: this.id } })

                }, error => {
                    this.generating = false
                    // l'errore di axios porta la risposta in error.response (assente se la richiesta non e' arrivata)
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: error?.response?.data?.message || 'Errore nella generazione degli ordini',
                        value: true,
                        color: 'error'
                    })
                })
            })
        },

        // Quantità da ordinare valida: numero >= 0 (0 = riga coperta dal magazzino)
        isValidQuantity(value) {
            if (value === '' || value === null || value === undefined) return false
            const n = parseFloat(value)
            return !isNaN(n) && n >= 0
        },

        availabilityColor(item) {
            if (item.available_quantity === null || item.available_quantity === undefined) return 'grey lighten-1'
            if (item.available_quantity <= 0) return 'grey'
            return item.available_quantity >= this.coverableQuantity(item) ? 'success' : 'warning'
        },

        availabilityTooltip(item) {
            if (item.available_quantity === null || item.available_quantity === undefined) {
                return 'Prodotto non movimentato a magazzino'
            }
            return `Giacenza: ${item.stock}, disponibile al netto degli altri ordini aperti`
        },

        // "Da magazzino" riduce solo la quantità da ordinare: niente movimenti. Il costo del materiale
        // arriva in commessa dal DDT di vendita che lo fa uscire.
        // Clampa tra 0 e la quantità rimanente; sopra la disponibilità avvisa senza bloccare.
        // Con normalize (change/blur) riscrive il campo con il valore numerico.
        onFromStockChange(item, normalize = false) {
            const parsed = parseFloat(item.from_stock)
            const coverable = this.coverableQuantity(item)
            let v = Math.max(0, isNaN(parsed) ? 0 : parsed)
            v = Math.min(v, coverable)
            if (normalize || (!isNaN(parsed) && v !== parsed)) {
                item.from_stock = v
            }
            item.quantity_to_order = Math.max(0, Math.round((coverable - v) * 100) / 100)
        },

        // Quantità ancora da coprire (magazzino o fornitore)
        coverableQuantity(item) {
            return Math.max(0, Math.round((parseFloat(item.quantity_remaining) || 0) * 100) / 100)
        },

        // Azione rapida: niente da magazzino, si ordina tutta la quantità da coprire
        resetFromStock() {
            let updatedCount = 0

            this.selectedRows.forEach(row => {
                if (row.type === 'kit' || row.type === 'description' || row.is_fully_ordered) return
                Vue.set(row, 'from_stock', 0)
                Vue.set(row, 'quantity_to_order', this.coverableQuantity(row))
                updatedCount++
            })

            this.filteredItems.forEach(item => {
                if (item.type !== 'kit' || !item.components) return
                item.components.forEach(comp => {
                    if (!comp.selected) return
                    Vue.set(comp, 'from_stock', 0)
                    Vue.set(comp, 'quantity_to_order', this.coverableQuantity(comp))
                    updatedCount++
                })
            })

            this.$store.commit('setSnackbar', {
                timeout: 3000,
                text: `Da magazzino azzerato su ${updatedCount} righe`,
                value: true,
                color: 'success'
            })
        },

        getRowClass(item) {
            if (item.is_fully_ordered) return 'row-disabled'
            if (item.type === 'kit') return 'row-kit'
            return ''
        },

    },
}
</script>

<style>

    tr.row-disabled td {
        opacity: 0.5 !important;
    }

    tr.row-kit {
        background-color: #f5f5f5 !important;
    }

    .components-table {
        background: transparent !important;
    }

    .no-max-height .v-data-table__wrapper {
        max-height: none !important;
    }

</style>
